import React from 'react'
import { Typography } from "@anchor/react-components/dist/lib/components";

function RegularTabContent({data, images}) {
  return (
    <>
    {data &&
              data ? (
                <Typography
                  style={{
                    // backgroundColor: "#f6fafb",
                    padding: "20px",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                  paragraph={true}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.replace(/\n/g, "<br/>"),
                    }}
                  />
                </Typography>
              ) : (
                <Typography
                  style={{
                    backgroundColor: "#E9F6FC",
                    padding: "20px",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                  paragraph={true}
                >
                  NA
                </Typography>
              )}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  padding: "20px",
                }}
              >
                {images &&
                  images.map(
                    (image, index) => {
                      return (
                        <img
                          style={{
                            maxHeight: "400px",
                            objectFit: "contain",
                          }}
                          id={index}
                          alt={image.name}
                          src={image.preview}
                        />
                      );
                    }
                  )}
              </div>
              {/* </div> */}
           
    </>
  )
}

export default RegularTabContent